module.exports = __webpack_public_path__ + "static/json-viewer-c3693ab00e214859a6f80146a95c1a64.png";